export default "__VITE_ASSET__esA_IPCz__"